import { h } from 'preact'
import ButtonControl from '../button-control'
import { common } from '../common'
import TitleInput from '../title-input/TitleInput'
import Icon from '../assets'
import Tooltip from '../ui-components/Tooltip'
import BetaBadge from '../ui-components/BetaBadge'
import BetaHeader from '../header/BetaHeader'

interface Props {
  type: string,
  isCustomView: boolean,
  title: string,
  onSaveViewClicked: () => void,
  onShareView: () => void,
  onTitleChanged: (title: string) => void
}

const Header = ({ type, isCustomView, title, onSaveViewClicked, onShareView, onTitleChanged }: Props) => {
  return (
    <div>
      <BetaHeader>
        ⭐️ How do you like the beta moderation overview? Tell us what you think.
        <ButtonControl
          onClick={() => window.open('https://community.insided.com/article/905?t=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJhcnRpY2xlX2lkIjo5MDV9.ujERTn6KV2Hq2o0tdkznD6FRJZ0XHE0vzcaQQjRbTKs')}
          title='Give Feedback'
          variant='brand'
          newStyle
          outlined
        />
        { !common.isModuleActive('moderationOverviewBetaForTeam') && <ButtonControl
          onClick={() => window.location.assign(window.location.origin + '/settings/experimental-features')}
          title='Enable for team'
          variant='brand'
          newStyle
          outlined
        />}
      </BetaHeader>
      <div class='control-header'>
        {isCustomView
          ? <TitleInput title={title} onTitleChanged={onTitleChanged}>
            <h2 class='control-header__title qa-title-text'>
              {title}<Icon icon='edit' width={20} height={20} />
            </h2>
          </TitleInput>
          : <h2 class='control-header__title'>{title}<BetaBadge /></h2>
        }
        {type !== 'ideation' && <div className='control-header__action-buttons'>
          <Tooltip
            trigger={<ButtonControl
              onClick={onShareView}
              title='Share view'
              class='qa-share-view'
            />}
            tooltipMessage={'Share current filter and column settings with your team mates via URL'}
            qaClasses='qa-save-view-tooltip'
            withArrow
            position='center'
          />
          <ButtonControl
            onClick={onSaveViewClicked}
            title='Save view'
            variant='success'
            class='save-view'
          />
        </div>}
      </div>
    </div>
  )
}

export default Header
